import {IRouletteBet} from "./IRouletteBet";

export class ColorBet implements IRouletteBet {
    constructor(public redColor: boolean, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/ColorBet.ts